import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GlobalConstants } from 'src/app/common/global';
import { Services } from 'src/app/services/api.service';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { HelperFunctionsService } from 'src/app/services/helper-functions.service';

@Injectable({
  providedIn: 'root',
})
export class ReturnTicketsService {
  private readonly cacheEvents = new Map<string, Observable<any[]>>();

  constructor(
    private readonly http: HttpClient,
    private readonly services: Services,
    private readonly errorMessageService: ErrorMessageService,
    private readonly helperFunctionsService: HelperFunctionsService
  ) {}

  validateBarcode(barcode: string): Observable<any> {
    const apiUrl = `${environment.apiUrl}/conn/${environment.connId}/v1/orders/checkMemberValidation`;

    return this.http.get<any>(`${apiUrl}/${barcode}`, GlobalConstants.headersCentral);
  }

  transferTicketService(itemId: number, memberProfileId: string, memberBarcode: number): Observable<any> {
    const apiUrl = `${environment.apiUrl}/conn/${environment.connId}/v1/orders/order/ticket-delegation`;
    const body = {
      itemId: itemId,
      memberProfileId: memberProfileId,
      memberBarcode: memberBarcode
    };

    return this.http.post<any>(apiUrl, body, GlobalConstants.headersCentral);
  }

  transferTicketToAnotherEmailService(transId: number, email: string): Observable<any> {
    const apiUrl = `${environment.apiUrl}/conn/${environment.connId}/v1/user/transactions/${transId}/ticketDelagationMail?email=${email}`;
    return this.http.post<any>(apiUrl, {}, GlobalConstants.headersCentral);
  }

  getListOfEvents(barcode: string, birthDate: string): Observable<any[]> {
    const key = `${barcode}|${birthDate}`;
    const forceReload = this.helperFunctionsService.forceReloadTransferTickets;

    if (!forceReload && this.cacheEvents.has(key)) {
      return this.cacheEvents.get(key)!;
    }

    const request$ = this.services.getGroupDetailsService(barcode, birthDate).pipe(
      map((response: any) => {
        if (!response.data || response.data.length === 0) {
          throw new Error(
            this.errorMessageService.getErrorMessage('noResultsForEnteredData')
          );
        }
        return response.data;
      }),
      shareReplay({ bufferSize: 1, refCount: true })
    );

    this.cacheEvents.set(key, request$);

    return request$;
  }
}
